module.exports = __webpack_public_path__ + "static/media/Excl_Sign.d09d69fc.svg";